<p-dialog
  header="Reschedule Task"
  [visible]="visible"
  (visibleChange)="visibleChange.emit($event)"
  [modal]="true"
  [style]="{ position: 'absolute', left: '60%' }"
  [closeOnEscape]="false"
  [closable]="false"
  (onShow)="onDialogShow()"
>
  <div class="ui-grid ui-grid-responsive ui-fluid">
    <div class="ui-grid-row" *ngIf="vehicle">
      <div style="padding: 0 0 5px 5px">
        <b
          >NOTE: To be used for an unfulfilled task and we want to display new times to the
          supplier.</b
        >
      </div>
    </div>
    <div class="ui-grid-row" *ngIf="vehicle">
      <div class="vehicle-information">Vehicle Information</div>
    </div>
    <div class="ui-grid-row" *ngIf="vehicle">
      <div class="ui-g-12">
        <div class="vehicle-detail">
          {{ vehicle.make }} {{ vehicle.model }} {{ vehicle.kerbWeight }}kg
        </div>
      </div>
    </div>
    <div class="task-locations-info" *ngIf="selectedTask">
      <div class="route-information">Route Information</div>
      <div class="ui-grid-row">
        <div class="ui-g-6">Pick-up: {{ selectedTask.pickupLocation.postcode | postcode }}</div>
        <div class="ui-g-6">Distance: {{ currentDistanceMiles }} miles</div>
      </div>
      <div class="ui-grid-row">
        <div class="ui-g-6">Drop-off: {{ selectedTask.dropoffLocation.postcode | postcode }}</div>
        <div class="ui-g-6">Travel Time: {{ getTravelTime() }}</div>
      </div>
    </div>
    <div class="ui-grid-row">
      <div class="ui-g-4"><label for="pickupEarliestDateTime">Pick-up Earliest:</label></div>
      <div class="ui-g-8 md-inputfield">
        <datetime-picker
          [(ngModel)]="pickupEarliestDateTime"
          id="pickupEarliestDateTime"
          name="pickupEarliestDateTime"
          [minutesInterval]="60"
          (ngModelChange)="alignDateTimes()"
        ></datetime-picker>

        <div *ngIf="diffPED.hasChanged" class="adjusted-by">
          Adjusted by
          <span *ngIf="diffPED.days != 0">{{ diffPED.days }} days </span>
          <span *ngIf="diffPED.hours != 0">{{ diffPED.hours }} hours </span>
          <span *ngIf="diffPED.minutes != 0">{{ diffPED.minutes }} minutes </span>
        </div>
      </div>
    </div>
    <div class="ui-grid-row">
      <div class="ui-g-4"><label for="pickupLatestDateTime">Pick-up Latest:</label></div>
      <div class="ui-g-8 md-inputfield">
        <datetime-picker
          [(ngModel)]="pickupLatestDateTime"
          id="pickupLatestDateTime"
          name="pickupLatestDateTime"
          [minutesInterval]="60"
          (ngModelChange)="alignDateTimes()"
        ></datetime-picker>

        <div *ngIf="diffPLD.hasChanged" class="adjusted-by">
          Adjusted by
          <span *ngIf="diffPLD.days != 0">{{ diffPLD.days }} days </span>
          <span *ngIf="diffPLD.hours != 0">{{ diffPLD.hours }} hours </span>
          <span *ngIf="diffPLD.minutes != 0">{{ diffPLD.minutes }} minutes </span>
        </div>
      </div>
    </div>

    <div class="ui-grid-row">
      <div class="ui-g-12"></div>
    </div>
    <div class="ui-grid-row">
      <div class="ui-g-4"><label for="dropoffEarliestDateTime">Drop-off Earliest:</label></div>
      <div class="ui-g-8 md-inputfield">
        <datetime-picker
          [(ngModel)]="dropoffEarliestDateTime"
          id="dropoffEarliestDateTime"
          name="dropoffEarliestDateTime"
          [minutesInterval]="60"
          (ngModelChange)="alignDateTimes()"
        ></datetime-picker>

        <div *ngIf="diffDED.hasChanged" class="adjusted-by">
          Adjusted by
          <span *ngIf="diffDED.days != 0">{{ diffDED.days }} days </span>
          <span *ngIf="diffDED.hours != 0">{{ diffDED.hours }} hours </span>
          <span *ngIf="diffDED.minutes != 0">{{ diffDED.minutes }} minutes </span>
        </div>
      </div>
    </div>
    <div class="ui-grid-row">
      <div class="ui-g-4"><label for="dropoffLatestDateTime">Drop-off Latest:</label></div>
      <div class="ui-g-8 md-inputfield">
        <datetime-picker
          [(ngModel)]="dropoffLatestDateTime"
          id="dropoffLatestDateTime"
          name="dropoffLatestDateTime"
          [minutesInterval]="60"
          (ngModelChange)="alignDateTimes()"
        ></datetime-picker>

        <div *ngIf="diffDLD.hasChanged" class="adjusted-by">
          Adjusted by
          <span *ngIf="diffDLD.days != 0">{{ diffDLD.days }} days </span>
          <span *ngIf="diffDLD.hours != 0">{{ diffDLD.hours }} hours </span>
          <span *ngIf="diffDLD.minutes != 0">{{ diffDLD.minutes }} minutes </span>
        </div>
      </div>
    </div>
  </div>

  <div class="ui-grid-row" *ngIf="otherTasks > 0" style="padding-left: 7px; padding-top: 5px">
    <p-checkbox
      [(ngModel)]="changeAllTasks"
      [label]="'Make same adjustments to other tasks in this order'"
    ></p-checkbox>
  </div>
  <p-footer>
    <div class="ui-grid-row">
      <button
        type="button"
        pButton
        icon="fa ui-icon-close"
        label="Close"
        (click)="visibleChange.emit(false)"
      ></button>
      <button
        type="button"
        class="green-btn"
        pButton
        icon="fa ui-icon-check"
        (click)="dialogSaveTaskClick()"
        label="Save"
      >
        <div *ngIf="savingReschedule" class="saving-checks">
          <i class="fa fa-spinner fa-spin fa-2x"></i>
        </div>
      </button></div
  ></p-footer>
</p-dialog>

<p-dialog
  header="Edit Task"
  [(visible)]="showConfirmDates"
  [responsive]="true"
  [modal]="true"
  [blockScroll]="true"
  [style]="{ width: '500px' }"
  [closeOnEscape]="false"
  [closable]="false"
>
  <div>
    The dates/times of this Task are outside the valid range. Are you sure you want to make these
    changes ?
  </div>
  <div class="mt-2 mb-2">
    <div style="display: flex; flex-wrap: wrap; align-items: center; justify-content: center">
      <div style="flex-grow: 1; flex-basis: 100px">
        <table class="show-confirm-dates previous-dates">
          <tr>
            <td colspan="2" class="header">Old Details</td>
          </tr>
          <tr>
            <td class="right">Pick-Up Earliest:</td>
            <td class="the-date">{{ previousPickupEarly | date : 'EEE dd MMM HH:mm' }}</td>
          </tr>
          <tr>
            <td class="right">Latest:</td>
            <td class="the-date">{{ previousPickupLate | date : 'EEE dd MMM HH:mm' }}</td>
          </tr>
          <tr>
            <td colspan="2">&nbsp;</td>
          </tr>
          <tr>
            <td class="right">Drop-Off Earliest:</td>
            <td class="the-date">{{ previousDropoffEarly | date : 'EEE dd MMM HH:mm' }}</td>
          </tr>
          <tr>
            <td class="right">Latest:</td>
            <td class="the-date">{{ previousDropoffLate | date : 'EEE dd MMM HH:mm' }}</td>
          </tr>
        </table>
      </div>
      <div style="width: 50px; font-size: 30px; height: 100%; text-align: center">
        <i class="fa fa-arrow-right"></i>
      </div>
      <div style="flex-grow: 1; flex-basis: 100px">
        <table class="show-confirm-dates new-dates">
          <tr>
            <td colspan="2" class="header">New Details</td>
          </tr>
          <tr>
            <td class="right">Pick-Up Earliest:</td>
            <td class="the-date">{{ pickupEarliestDateTime | date : 'EEE dd MMM HH:mm' }}</td>
          </tr>
          <tr>
            <td class="right">Latest:</td>
            <td class="the-date">{{ pickupLatestDateTime | date : 'EEE dd MMM HH:mm' }}</td>
          </tr>
          <tr>
            <td colspan="2">&nbsp;</td>
          </tr>
          <tr>
            <td class="right">Drop-Off Earliest:</td>
            <td class="the-date">{{ dropoffEarliestDateTime | date : 'EEE dd MMM HH:mm' }}</td>
          </tr>
          <tr>
            <td class="right">Latest:</td>
            <td class="the-date">{{ dropoffLatestDateTime | date : 'EEE dd MMM HH:mm' }}</td>
          </tr>
        </table>
      </div>
    </div>
  </div>

  <div style="text-align: right; padding-top: 20px">
    <button pButton label="Cancel" class="red-btn" (click)="undoChanges()"></button>
    <button pButton label="Continue" class="green-btn" (click)="saveTaskData()"></button>
  </div>
</p-dialog>
